import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { ImageComponent } from 'common-ui';
import { CarouselComponent, CarouselItemDirective } from 'page-layouts-ui';
import { CommonProductDetailsComponentBase } from '../../CommonProductDetailsComponentBase';

@Component({
  selector: 'ideal-product-image-viewer',
  imports: [CarouselComponent, CarouselItemDirective, ImageComponent],
  standalone: true,
  templateUrl: './product-image-viewer.component.html',
  styleUrl: './product-image-viewer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductImageViewerComponent extends CommonProductDetailsComponentBase {
  protected readonly ready = computed(() => !this.productDetails.error() && !this.productDetails.loading() && !!this.productDetails());
  protected readonly showControls = computed(() => this.images().length > 1);

  protected readonly images = computed(() => {
    const product = this.productDetails();
    if (!product || !product.id || !product.id.lineCode || !product.id.partNumber) {
      return [];
    }
    const length = product.images ?? 1;
    return Array.from(
      { length },
      (_, i) =>
        `https://api.idealsupply.com/products/v1/thumbnail/${encodeURIComponent(product.id!.lineCode)}${encodeURIComponent(product.id!.partNumber)}?ImageIndex=${i}`,
    );
  });
}
